import React from "react";
import { CreateActionDialog } from "./dialogs/CreateActionDialog";
import { EditActionDialog } from "./dialogs/EditActionDialog";
import { ViewActionDialog } from "./dialogs/ViewActionDialog";
import { RespondActionDialog } from "./dialogs/RespondActionDialog";
import {
  DialogActionArgument,
  DialogActionType,
  DialogActionTypeWithAction,
} from "./types";
import { UploadRespondActionDialog } from "./dialogs/UploadRespondActionDialog";
import { Dialog } from "@material-ui/core";
import { DeleteActionDialog } from "./dialogs/DeleteActionDialog";

type RenderDialogProps = {
  focussedDialog: DialogActionArgument;
  onClose: () => void;
  organisationRecipientId?: string;
  itemId?: string;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focussedDialog,
  onClose,
  organisationRecipientId,
  itemId,
}) => {
  if (focussedDialog === null) {
    return null;
  }

  const focussedDialogCompound = focussedDialog as DialogActionTypeWithAction;
  const focussedDialogSimple = focussedDialog as DialogActionType;

  const { dialogActionType, action } = focussedDialogCompound.action
    ? focussedDialogCompound
    : { dialogActionType: focussedDialogSimple, action: undefined };

  switch (dialogActionType) {
    case DialogActionType.CreateAction:
      return <CreateActionDialog onClose={onClose} />;
    case DialogActionType.CreateActionUploadDocuments:
      return <CreateActionDialog onClose={onClose} isDocuments />;
    case DialogActionType.CreateActionRespondWithDocuments:
      return <CreateActionDialog onClose={onClose} isRespondWithDocuments />;
    case DialogActionType.EditAction:
      return <EditActionDialog onClose={onClose} action={action!} />;
    case DialogActionType.ViewAction:
      return <ViewActionDialog onClose={onClose} action={action!} />;
    case DialogActionType.DeleteAction:
      return <DeleteActionDialog onClose={onClose} action={action!} />;
    case DialogActionType.RespondToMessage:
      return (
        <RespondActionDialog
          onClose={onClose}
          action={action!}
          organisationRecipientId={organisationRecipientId!}
          itemId={itemId!}
        />
      );
    case DialogActionType.RespondWithDocuments:
      return (
        <UploadRespondActionDialog
          onClose={onClose}
          action={action!}
          organisationRecipientId={organisationRecipientId!}
          itemId={itemId!}
        />
      );
    default:
      return null;
  }
};
